import React from 'react';
import TypedOrderForm from './TypedOrderForm';

/**
 * Create Copywrite Order — requested by accounting (Ariane, 2026-09-17), built on the KIND
 * form. Product decisions that shape it:
 *   - Function is always Copywriting (no dropdown), the same word as the talent function.
 *   - Location is a dropdown: Remote or EB5 (changed from a fixed "Copywrite" on 2026-09-21).
 *   - Set is "Copywrite".
 *   - Billing offers Day / Hourly / KPI like KIND.
 *   - Clients and their default cost centers live in Settings → Order clients → Copywrite.
 */
export const COPYWRITE_ORDER_CONFIG = {
  orderType: 'copywrite',
  title: 'Create Copywrite Order',
  noun: 'Copywrite Order',
  buttonLabel: 'Create Copywrite Order',
  // Same word as the talents' function (Funktion "Copywriting"), so orders and talents match
  // 1:1. Orders created before 2026-09-22 still say "Copywriter"; Propose Talent treats both
  // as the same function.
  positions: [{ value: 'Copywriting', label: 'Copywriting' }],
  defaultPosition: 'Copywriting',
  fixedPosition: true,
  // Studio stays the fixed "Remote" like KIND. LOCATION is a dropdown Remote / EB5 (Ariane
  // 2026-09-21), Remote preselected. EB5 resolves to the real location record; "Remote" has no
  // record and is stored as a label, like KIND's CGI fallback.
  studio: 'Remote',
  locations: [
    { value: 'remote', label: 'Remote', match: [] },
    { value: 'eb5', label: 'EB5', match: ['Essener Bogen 5, 22419 Hamburg'] },
  ],
  fixedLocation: false,
  set: 'Copywriting', // same word as the talents' type/Bereich (was "Copywrite" until 2026-09-22)
  billing: ['daily', 'hourly', 'kpi'],
  infoLabel: 'Copywrite Info',
  infoPlaceholder: 'Copywrite-specific information (optional)',
  groupPrefix: 'copywrite',
};

function CreateCopywriteOrder() {
  return <TypedOrderForm config={COPYWRITE_ORDER_CONFIG} />;
}

export default CreateCopywriteOrder;
